<template>
  <div class="top desktop-index">
    <div class="left">
      <img
        class="paar"
        src="@/assets/images/top/top_paar2.png"
        alt=""
        :class="$mq"
      />
      <div class="trailer" :class="$mq">
        <div v-if="$config.youtube.display">
          <div @click="ytVideo" class="open-trailer" style="position: relative">
            <video src="@/assets/videos/sizzle.mp4" loop muted autoplay></video>
            <div class="trailer-misc">
              <img
                class="play-btn"
                src="@/assets/images/youtube/play.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <img
        :src="require(`@/assets/images/top/` + $config.tt)"
        alt=""
        :class="$mq"
      />
    </div>
    <div class="cite" :class="$mq">
      <img src="@/assets/images/top/top_cite.png" alt="" :class="$mq" />
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  methods: {
    ytVideo() {
      EventBus.$emit('open-yt-1')
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100vh - 220px);
  background: transparent url('@/assets/images/top/bg.jpg') top center no-repeat;
  background-size: cover;
  overflow: hidden;
  .cite {
    position: absolute;
    left: 50%;
    top: 5%;
    transform: translateX(-50%);
    &.lg {
      width: 33%;
      img {
        width: 100%;
      }
    }
  }
  .left,
  .right {
    width: 50%;
    position: absolute;
    top: 0;
  }
  .left {
    left: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .paar {
      height: 100%;
    }
    .trailer {
      position: absolute;
      bottom: 8%;
      right: -5%;
      width: 516px;
      height: 288px;
      border: 2px solid white;
      cursor: pointer;
      video {
        width: 512px;
        height: 284px;
      }
      .trailer-misc {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 111;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      &.lg {
        right: 0;
        bottom: 10%;
        width: 260px;
        height: 148px;
        video {
          width: 256px;
          height: 144px;
        }
        .trailer-misc {
          img {
            width: 50%;
          }
        }
      }
      &.xl {
        right: 0;
        bottom: 4%;
        width: 386px;
        height: 218px;
        video {
          width: 384px;
          height: 214px;
        }
        .trailer-misc {
          img {
            width: 50%;
          }
        }
      }
    }
  }
  .right {
    left: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      mix-blend-mode: multiply;
      width: 60%;
      &.lg {
        width: 65%;
        margin-right: 70px;
        margin-bottom: -50px;
      }
      &.xl {
        width: 70%;
        margin-right: 70px;
        margin-bottom: -50px;
      }
    }
  }
}
</style>
